import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCross, faListAlt, faTshirt, faMapMarkerAlt, faMusic, faCheck } from '@fortawesome/free-solid-svg-icons';
import LeftSleeve from './images/Left-Sleeve-and-Insignia-Pl.jpg';
import RightSleeve from './images/Right-Sleeve-and-Insignia-P.webp';
import adventurersSong from './images/we_are_adventurers_music.jpg';
import planningCommitImage from './images/planning_committee_in_adventurers_uniform.jpg';

const Adventurers = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  const sections = [
    { id: 'Philosophy-Objectives', title: 'Philosophy & Objectives' },
    { id: 'Pledge-Law', title: 'Pledge & Law' },
    { id: 'Uniform', title: 'Uniform' },
    { id: 'Insignia-Placement', title: 'Insignia Placement' },
    { id: 'Song', title: 'Song' },
    { title: 'Pathfinders', href: 'Pathfinders' },
    { title: 'Ambassadors', href: 'Ambassadors' },
    { title: 'Young Adults', href: 'YoungAdults' },
    { title: 'PCM', href: 'PCM' }
  ];

  return (
    <>
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-indigo-50">
        <Header />
        
        <main className="pt-24">
          <div className="max-w-7xl mx-auto px-4">
            {/* Navigation */}
            <nav className="mb-12">
              <div className="flex flex-wrap gap-2 justify-center">
                {sections.map((section, idx) => (
                  section.href ? (
                    <a
                      key={idx}
                      href={section.href}
                      className="bg-gradient-to-r from-purple-600 to-indigo-600 text-white px-6 py-3 rounded-full font-semibold hover:from-purple-700 hover:to-indigo-700 transform hover:scale-105 transition-all duration-300 shadow-lg"
                    >
                      {section.title}
                    </a>
                  ) : (
                    <a
                      key={idx}
                      href={`#${section.id}`}
                      className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-6 py-3 rounded-full font-semibold hover:from-blue-700 hover:to-cyan-700 transform hover:scale-105 transition-all duration-300 shadow-lg"
                    >
                      {section.title}
                    </a>
                  )
                ))}
              </div>
            </nav>

            {/* Content Sections */}
            <div className="space-y-20">
              {/* Philosophy & Objectives */}
              <section id="Philosophy-Objectives" className="scroll-mt-24">
                <div className="grid md:grid-cols-2 gap-8">
                  <div className="bg-gradient-to-br from-white to-blue-50 rounded-3xl shadow-2xl p-8 transform hover:-translate-y-1 transition-transform duration-300">
                    <div className="flex items-center mb-6">
                      <div className="bg-gradient-to-r from-blue-500 to-cyan-500 p-3 rounded-xl mr-4">
                        <FontAwesomeIcon icon={faCross} className="text-white text-2xl" />
                      </div>
                      <h2 className="text-3xl font-bold text-gray-800">PHILOSOPHY</h2>
                    </div>
                    <p className="text-gray-600 leading-relaxed text-lg">
                      The Adventurer Club is a Seventh-day Adventist church-sponsored ministry open to all children ages 4-9, in which the church, home, and school join together to help children grow joyfully in wisdom and stature and in favor with God and man.
                      The Adventurer Club is offered to assist parents in making the development of their child richer and more meaningful.
                      The Adventurer Club provides fun and creative ways for children.
                    </p>
                  </div>

                  <div className="bg-gradient-to-br from-white to-emerald-50 rounded-3xl shadow-2xl p-8 transform hover:-translate-y-1 transition-transform duration-300">
                    <div className="flex items-center mb-6">
                      <div className="bg-gradient-to-r from-emerald-500 to-green-500 p-3 rounded-xl mr-4">
                        <FontAwesomeIcon icon={faListAlt} className="text-white text-2xl" />
                      </div>
                      <h2 className="text-3xl font-bold text-gray-800">Objectives</h2>
                    </div>
                    <ol className="space-y-4">
                      {[
                        'to develop a Christ-like character;',
                        'to experience the joy and satisfaction of doing things well;',
                        'to express their love for Jesus in a natural way;',
                        'to learn good sportsmanship and strengthen their ability to get along with others;',
                        'to discover their God-given abilities and to learn how to use them to benefit self and serve others;',
                        'to discover God\'s world;',
                        'to improve their understanding of what makes families strong;',
                        'to develop parental support for the training of children.'
                      ].map((item, idx) => (
                        <li key={idx} className="flex items-start">
                          <FontAwesomeIcon icon={faCheck} className="text-emerald-500 mt-1 mr-3" />
                          <span className="text-gray-600">{item}</span>
                        </li>
                      ))}
                    </ol>
                  </div>
                </div>
              </section>

              {/* Pledge & Law */}
              <section id="Pledge-Law" className="scroll-mt-24">
                <div className="grid md:grid-cols-2 gap-8">
                  <div className="bg-gradient-to-br from-white to-amber-50 rounded-3xl shadow-2xl p-8">
                    <div className="flex items-center mb-6">
                      <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-3 rounded-xl mr-4">
                        <FontAwesomeIcon icon={faCross} className="text-white text-2xl" />
                      </div>
                      <h2 className="text-3xl font-bold text-gray-800">Pledge</h2>
                    </div>
                    <div className="bg-gradient-to-r from-amber-100 to-orange-100 p-6 rounded-2xl">
                      <p className="text-2xl font-serif text-gray-700 italic text-center">
                        "Because Jesus loves me, I can always do my best."
                      </p>
                    </div>
                  </div>

                  <div className="bg-gradient-to-br from-white to-rose-50 rounded-3xl shadow-2xl p-8">
                    <div className="flex items-center mb-6">
                      <div className="bg-gradient-to-r from-rose-500 to-pink-500 p-3 rounded-xl mr-4">
                        <FontAwesomeIcon icon={faListAlt} className="text-white text-2xl" />
                      </div>
                      <h2 className="text-3xl font-bold text-gray-800">Law</h2>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                      {[
                        'Be obedient', 'Be pure', 'Be true', 'Be kind',
                        'Be respectful', 'Be attentive', 'Be helpful',
                        'Be cheerful', 'Be thoughtful', 'Be reverent'
                      ].map((item, idx) => (
                        <div key={idx} className="bg-gradient-to-r from-rose-50 to-pink-50 p-3 rounded-xl flex items-center">
                          <FontAwesomeIcon icon={faCheck} className="text-rose-500 mr-2" />
                          <span className="text-gray-700 font-medium">{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </section>

              {/* Uniform */}
              <section id="Uniform" className="scroll-mt-24">
                <div className="bg-gradient-to-br from-white to-blue-50 rounded-3xl shadow-2xl p-8">
                  <div className="flex items-center justify-center mb-8">
                    <div className="bg-gradient-to-r from-blue-500 to-indigo-500 p-4 rounded-xl mr-4">
                      <FontAwesomeIcon icon={faTshirt} className="text-white text-3xl" />
                    </div>
                    <h2 className="text-4xl font-bold text-gray-800">Uniform</h2>
                  </div>

                  <div className="grid md:grid-cols-2 gap-8">
                    <div className="space-y-6">
                      <div className="bg-white rounded-2xl p-6 shadow-lg">
                        <h3 className="text-xl font-bold text-gray-800 mb-4">Class "A" Uniform for the Adventurer boy and girl</h3>
                        <div className="space-y-3">
                          <div className="flex items-start">
                            <span className="font-semibold text-blue-600 min-w-20">GIRLS</span>
                            <span className="text-gray-600">Navy blue pinafore or skirt, white blouse (shirt type blouse with short sleeves).</span>
                          </div>
                          <div className="flex items-start">
                            <span className="font-semibold text-blue-600 min-w-20">BOYS</span>
                            <span className="text-gray-600">Navy blue pants, white shirt with short sleeves and regular collar.</span>
                          </div>
                          <div className="flex items-start">
                            <span className="font-semibold text-blue-600 min-w-32">BOYS/GIRLS</span>
                            <span className="text-gray-600">Shoes: uniform within club; Navy blue or white socks: uniform within club.</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="space-y-6">
                      <div className="bg-white rounded-2xl p-6 shadow-lg">
                        <h3 className="text-xl font-bold text-gray-800 mb-4">Field Uniform (Type B)</h3>
                        <p className="text-gray-600 mb-4">Field uniform for the Adventurers and staff is a T-shirt and blue jeans. Each club may create its own design for field uniform T-shirts and sweatshirts.</p>
                        <ul className="space-y-2">
                          <li className="flex items-center">
                            <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                            <span className="text-gray-600">Adventurer logo</span>
                          </li>
                          <li className="flex items-center">
                            <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                            <span className="text-gray-600">Local club logo</span>
                          </li>
                          <li className="flex items-center">
                            <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                            <span className="text-gray-600">Adventurer and local club logo</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {/* Insignia Placement */}
              <section id="Insignia-Placement" className="scroll-mt-24">
                <div className="bg-gradient-to-br from-white to-emerald-50 rounded-3xl shadow-2xl p-8">
                  <div className="flex items-center justify-center mb-8">
                    <div className="bg-gradient-to-r from-emerald-500 to-green-500 p-4 rounded-xl mr-4">
                      <FontAwesomeIcon icon={faMapMarkerAlt} className="text-white text-3xl" />
                    </div>
                    <h2 className="text-4xl font-bold text-gray-800">INSIGNIA PLACEMENT</h2>
                  </div>

                  <div className="grid md:grid-cols-2 gap-8 mb-8">
                    <div className="bg-white rounded-2xl p-6 shadow-lg">
                      <h3 className="text-xl font-bold text-gray-800 mb-4">LEFT SLEEVE</h3>
                      <p className="text-gray-600 mb-4">The Adventurer World emblem is to be worn on left sleeve 1½" below the shoulder seam.</p>
                      <img src={LeftSleeve} alt="Left Sleeve" className="rounded-xl shadow-md" />
                    </div>

                    <div className="bg-white rounded-2xl p-6 shadow-lg">
                      <h3 className="text-xl font-bold text-gray-800 mb-4">RIGHT SLEEVE</h3>
                      <p className="text-gray-600 mb-4">The Adventurer Club Name Crescent is to be worn ½" below the shoulder seam. The Adventurer Club Emblem is to be worn 2½" down from the shoulder seam.</p>
                      <img src={RightSleeve} alt="Right Sleeve" className="rounded-xl shadow-md" />
                    </div>
                  </div>

                  <div className="grid md:grid-cols-3 gap-6">
                    <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-2xl p-6">
                      <h4 className="text-lg font-bold text-gray-800 mb-3">SASH</h4>
                      <p className="text-gray-600">Adventurer awards and class pins, only. If you have earned any AY/Pathfinder Honors you are not to place them on your sash.</p>
                    </div>

                    <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl p-6">
                      <h4 className="text-lg font-bold text-gray-800 mb-3">NAME TAG</h4>
                      <p className="text-gray-600">Your name tag is to be centered over the right pocket or its equivalent position on the sash or blouse.</p>
                    </div>

                    <div className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-2xl p-6">
                      <h4 className="text-lg font-bold text-gray-800 mb-3">STAFF</h4>
                      <p className="text-gray-600">Your staff rank stripe goes between the club name crescent and the Adventurer Club Emblem. Move the Adventurer Club Emblem down an extra inch.</p>
                    </div>
                  </div>
                </div>
              </section>

              {/* Song */}
              <section id="Song" className="scroll-mt-24">
                <div className="bg-gradient-to-br from-white to-purple-50 rounded-3xl shadow-2xl p-8">
                  <div className="flex items-center justify-center mb-8">
                    <div className="bg-gradient-to-r from-purple-500 to-pink-500 p-4 rounded-xl mr-4">
                      <FontAwesomeIcon icon={faMusic} className="text-white text-3xl" />
                    </div>
                    <h2 className="text-4xl font-bold text-gray-800">Song</h2>
                  </div>
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <img src={adventurersSong} alt="Adventurer Song" className="rounded-xl shadow-md w-full max-w-2xl mx-auto" />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}

export default Adventurers;